import { erpSystemReducer } from './erpSystem/slice';
import { salesOrganizationReducer } from './salesOrganisation/slice';
import { paginationReducer } from './pagination/slice';
import { stepReducer } from './step/slice';
import { notificationsReducer } from './notifications/slice';
import { modalReducer } from './modal/slice';
import { configuratorDataReducer } from './configuratorData/slice';
import { selectedFiltersReducer } from './selectedFilters/slice';
import { searchReducer } from './search/slice';
import { priceReducer } from './price/slice';
import { stockReducer } from './stock/slice';
import { selectedItemReducer } from './selectedItem/slice';
import { metadataReducer } from './metadata/slice';
import { selectServiceDataReducer } from './selectService/slice';
import { errorNotifyReducer } from './errorNotifications/slice';
import { insertsReducer } from './inserts/slice';
import { quoteInformationReducer } from './quote/slice';
import { sapConfigurationReducer } from './sapConfiguration/slice';
import { stemExtensionsDataReducer } from './stemExtensions/slice';
import { mountingPartReducer } from './mountingPart/slice';
import { pucksReducer } from './pucks/slice';
import { speedControlBlockReducer } from './speedControlBlock/slice';
import { mountingPlateReducer } from './mountingPlate/slice';
import { couplingsAndBracketsReducer } from './couplings/slice';
// [IMPORT NEW REDUCER ABOVE] < Needed for generating containers seamlessly

const reducers = {
  erpSystem: erpSystemReducer,
  salesOrganization: salesOrganizationReducer,
  configuratorData: configuratorDataReducer,
  pagination: paginationReducer,
  step: stepReducer,
  notifications: notificationsReducer,
  modal: modalReducer,
  selectedFilters: selectedFiltersReducer,
  search: searchReducer,
  price: priceReducer,
  stock: stockReducer,
  itemValues: selectedItemReducer,
  metadata: metadataReducer,
  selectServiceData: selectServiceDataReducer,
  errorNotify: errorNotifyReducer,
  inserts: insertsReducer,
  quoteInformation: quoteInformationReducer,
  sapConfiguration: sapConfigurationReducer,
  stemExtensionsData: stemExtensionsDataReducer,
  mountingPart: mountingPartReducer,
  pucks: pucksReducer,
  speedControlBlock: speedControlBlockReducer,
  mountingPlate: mountingPlateReducer,
  couplingsAndBrackets: couplingsAndBracketsReducer,
  // [ADD NEW REDUCER KEY ABOVE] < Needed for generating containers seamlessly
};

export { reducers };
